// apiService.js
import axios, { AxiosError } from 'axios';
export { AxiosError };


export class THEachError {
    public detail: string = '';
}

let getAccessToken: (() => string | null) | null = null;
let refreshAccessToken: (() => Promise<void>) | null = null;

// Function to set the token provider
export const setAuthTokenProvider = (
    tokenProvider: () => string | null,
    refreshTokenProvider: () => Promise<void>
) => {
    getAccessToken = tokenProvider;
    refreshAccessToken = refreshTokenProvider;
};

// Axios instance
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND,
    withCredentials: true, // Required if you're using httpOnly cookies
});


// Function to get the client ID from session storage
const getClientId = () => {
    return sessionStorage.getItem('clientId');
};


// Request interceptor
apiClient.interceptors.request.use(
    (config) => {

        //console.log("axios interceptor for request");
        const clientId = getClientId();
        if (clientId) {
            config.headers['X-Client-ID'] = clientId;
        }

        if (getAccessToken) {
            const token = getAccessToken(); // Get token from AuthProvider
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


apiClient.interceptors.response.use(
    // Response interceptor
    async (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Check if error is a 401 Unauthorized
        if (axios.isAxiosError(error) && error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // Prevent infinite loop

            if (refreshAccessToken) {
                try {
                    await refreshAccessToken(); // Call refresh function from AuthProvider
                    return apiClient(originalRequest); // Retry original request with new token
                } catch (refreshError) {
                    console.error("Refresh token failed, logging out...");
                    return Promise.reject(refreshError);
                }
            }
        }


        /*
        //const originalRequest = error.config;
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            if (axiosError.response?.status === 401) {
                // Redirect to login page
                window.location.href = '/';
            } else {
                // Handle other errors
                console.error('Request failed:', axiosError.message);
            }
        } else {
            // Handle non-Axios errors
            console.error('Request failed:', error);
        }

        */


        return Promise.reject(error);
    }
);

/*
const getStoredAccessToken = () => {
    return localStorage.getItem("authToken")
};
*/
/*
// Function to refresh the tokens
const refreshToken = async (accessToken: string) => {
    try {
        // Make a request to your server's token refresh endpoint
        const response = await axios.post(process.env.REACT_APP_BACKEND + '/refresh-token', {},
            {
                headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                },
                withCredentials: true
            });

        // Extract and return the new access token and refresh token
        const newAccessToken = response.data.access_token;
        //const newRefreshToken = response.data.refresh_token;
        //return { accessToken: newAccessToken, refreshToken: newRefreshToken };
        return newAccessToken;
    } catch (error) {
        // Handle token refresh failure (e.g., redirect to login page)
        console.error('Token refresh failed:', error);
        throw error;
    }
};

// Function to update the stored tokens
const updateStoredAccessToken = (newAccessToken: string) => {
    // Update the stored access token and refresh token in localStorage or sessionStorage
    localStorage.setItem('authToken', newAccessToken);
    //localStorage.setItem('refreshToken', newRefreshToken);
};

const redirectToLogin = () => {
    // Use the appropriate navigation mechanism to redirect to the login page
    // This example assumes you are using react-router-dom
    // Replace with your actual routing mechanism or logic
    window.location.href = '/';
};
*/

export const handleAPIError = (error: any) => {
    if (axios.isAxiosError(error) && error?.response) {
        const axiosError = error as AxiosError;
        const errorResponse = axiosError.response?.data as THEachError;
        return errorResponse.detail
    }
    return null
}


export default apiClient;
